import { format } from "date-fns/format";

import { convertTimeToDate } from "../utils";

export const formatTime = (time: string) => {
  const formattedTime = convertTimeToDate(time);
  const timeFormat = formattedTime.getMinutes() !== 0 ? "h.mm aaa" : "h aaa";

  return format(formattedTime, timeFormat);
};
